import { Component } from '@angular/core';
// ES6 Modules or TypeScript
import Swal from 'sweetalert2';

// CommonJS

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent {
  title = 'crm';
  constructor(){  }
  envia(){
    console.log('envia');
    Swal.fire({
      allowOutsideClick: false,
      icon: 'info',
      text: 'Espere por favor..'
    });
  }
}

